export const API_URL = 'https://api.quantumaxis.com.br/widgets/v1/'

export const API_SUBSCRIPTION_KEY = '79e477b0dace44c1bb0b54e06fc8103b'

export const HOME_TITLE = 'Comparador de ativos Banco do Brasil'

export const THEME = 'bb'

export const REDUX_PANE = false;
export const REDUX_LOGGER = false;
export const SHARE_URL = 'default';
